import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdH1HeadLine = (props) => {
  return <LSBdH1HeadLineWrapper {...props} />;
};

export default LSBdH1HeadLine;

const LSBdH1HeadLineWrapper = styled(LineSeedKrBd)`
  font-size: 16px;
  font-weight: 700;
  line-height: 22.4px;
  letter-spacing: -0.6px;

  color: #222222;
`;
